import type { MessagesWithAds } from '@/components/chat'

interface AdsCardProps {
  msg: MessagesWithAds | null
}
const AdsCard = ({ msg }: AdsCardProps) => {
  return (
    <div className='flex justify-center w-full'>
      <div className='w-full sticky top-0 left-0 right-0 max-w-[100%] bg-white z-10 text-gray-800 text-sm leading-relaxed whitespace-pre-wrap break-words'>
        <a
          href={msg?.redirect_url}
          target='_blank'
          rel='noopener noreferrer'
          className='text-blue-500 hover:underline'
        >
          <img
            src={msg?.ad_image}
            alt={msg?.company_name ?? ''}
            className='h-[60px] w-full object-contain block'
          />
        </a>
        {/* <p className="mt-1">{msg?.company_name}</p> */}
      </div>
    </div>
  )
}

export default AdsCard
